/** Returns an in-app path from a `next` parameter, or `fallback` if it could leave the app. */
export function safeNextPath(value: string | null, fallback = '/dashboard'): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) {
    return fallback;
  }
  return value;
}
